import { AbstractControl, ValidatorFn } from '@angular/forms';

export const calculatePasswordStrength = (password: string) => {
  let strength = 0;
  if (!password) {
    return 0;
  }

  if (8 <= password.length) {
    strength++;
  }
  if (12 <= password.length) {
    strength++;
  }
  if ((password.match(/[a-z]/)) || (password.match(/[A-Z]/))) {
    strength++;
  }
  if (password.match(/\d+/)) {
    strength++;
  }
  if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,),+,',"]/)) {
    strength++;
  }

  return password.length < 8 ? Math.min(2, strength) : strength;
}

export const passwordValidator: ValidatorFn = (control: AbstractControl) => {
  return calculatePasswordStrength(control.value) >= 3
    ? null
    : { passwordStrength: 'The given password is not strong enough' };
}

